export const ID = "id";
export const TAGS = "tags";
export const WHATSAPP_OPTED_IN = "whatsapp_opted_in";
export const SMS_OPTED_IN = "sms_opted_in";
export const NAME = "name";
export const PHONE_NUMBER = "phone_number";
export const EMAIL = "email";
export const CONTACT = "contact";
export const COUNTRY_CODE = "country_code";
